(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bn.js"), require("source-map-support"));
	else if(typeof define === 'function' && define.amd)
		define("Ganache-Cli", ["bn.js", "source-map-support"], factory);
	else if(typeof exports === 'object')
		exports["Ganache-Cli"] = factory(require("bn.js"), require("source-map-support"));
	else
		root["Ganache-Cli"] = factory(root["bn.js"], root["source-map-support"]);
})(global, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__435__) {
return 